(function (root, factory) {
  var utils = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = utils;
  }

  root.ElazProductShippingUtils = utils;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function normalizePostalCode(value) {
    var digits = String(value === null || value === undefined ? '' : value).replace(/\D/g, '');

    return digits.length === 8 ? digits : null;
  }

  function normalizedId(value) {
    if (value === null || value === undefined) {
      return null;
    }

    var id = String(value).trim();
    return id ? id : null;
  }

  function validQuantity(value) {
    return Number.isInteger(value) && value > 0;
  }

  function consolidateSimulationItems(items) {
    var quantities = new Map();
    var order = [];

    (Array.isArray(items) ? items : []).forEach(function (item) {
      var id = item && normalizedId(item.id);
      var quantity = Math.floor(Number(item && item.quantity));

      if (!id || !validQuantity(quantity)) {
        return;
      }

      if (!quantities.has(id)) {
        quantities.set(id, 0);
        order.push(id);
      }
      quantities.set(id, quantities.get(id) + quantity);
    });

    return order.map(function (id) {
      return { id: id, quantity: quantities.get(id) };
    });
  }

  function availableVariant(product, variantId) {
    var id = normalizedId(variantId);
    var variants = product && Array.isArray(product.variants) ? product.variants : [];

    if (!id) {
      return null;
    }

    return variants.find(function (variant) {
      return variant && variant.available && normalizedId(variant.id) === id;
    }) || null;
  }

  function firstAvailableVariant(products) {
    var safeProducts = Array.isArray(products) ? products : [];

    for (var productIndex = 0; productIndex < safeProducts.length; productIndex += 1) {
      var variants = safeProducts[productIndex] && Array.isArray(safeProducts[productIndex].variants)
        ? safeProducts[productIndex].variants
        : [];
      var variant = variants.find(function (candidate) {
        return candidate && candidate.available && normalizedId(candidate.id);
      });

      if (variant) {
        return variant;
      }
    }

    return null;
  }

  function buildComboSimulationItems(steps, products, quantity) {
    if (!validQuantity(quantity)) {
      return [];
    }

    var safeProducts = Array.isArray(products) ? products : [];
    var selectedIds = [];

    (Array.isArray(steps) ? steps : []).forEach(function (step) {
      if (!step || !Number.isInteger(step.productIndex) || step.productIndex < 0) {
        return;
      }

      var variant = availableVariant(safeProducts[step.productIndex], step.variantId);
      if (variant) {
        selectedIds.push(normalizedId(variant.id));
      }
    });

    var fallback = firstAvailableVariant(safeProducts);
    var lastId = selectedIds.length ? selectedIds[selectedIds.length - 1] : fallback && normalizedId(fallback.id);

    if (!lastId) {
      return [];
    }

    while (selectedIds.length < quantity) {
      selectedIds.push(lastId);
    }

    return consolidateSimulationItems(selectedIds.slice(0, quantity).map(function (id) {
      return { id: id, quantity: 1 };
    }));
  }

  function nonEmptyProperties(properties) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      return null;
    }

    var keys = Object.keys(properties);
    if (!keys.length) {
      return null;
    }

    return keys.reduce(function (copy, key) {
      defineOwn(copy, key, copiedValue(properties[key]));
      return copy;
    }, {});
  }

  function defineOwn(target, key, value) {
    Object.defineProperty(target, key, {
      configurable: true,
      enumerable: true,
      value: value,
      writable: true,
    });
  }

  function copiedValue(value) {
    if (Array.isArray(value)) {
      return value.map(copiedValue);
    }

    if (value && typeof value === 'object') {
      return Object.keys(value).reduce(function (copy, key) {
        defineOwn(copy, key, copiedValue(value[key]));
        return copy;
      }, {});
    }

    return value;
  }

  function sellingPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    var allocationPlan = allocation && allocation.selling_plan;
    var fromAllocation = allocationPlan && normalizedId(allocationPlan.id);

    return fromAllocation || normalizedId(item && item.selling_plan);
  }

  function snapshotCartItems(cartOrItems) {
    var items = Array.isArray(cartOrItems)
      ? cartOrItems
      : cartOrItems && Array.isArray(cartOrItems.items) ? cartOrItems.items : [];

    return items.reduce(function (snapshot, item) {
      var id = item && (normalizedId(item.variant_id) || normalizedId(item.id));

      if (!id || !item || !validQuantity(item.quantity)) {
        return snapshot;
      }

      var line = { id: id, quantity: item.quantity };
      var properties = nonEmptyProperties(item.properties);
      var sellingPlan = sellingPlanId(item);

      if (properties) {
        line.properties = properties;
      }
      if (sellingPlan) {
        line.selling_plan = sellingPlan;
      }

      snapshot.push(line);
      return snapshot;
    }, []);
  }

  function sortedValue(value) {
    if (Array.isArray(value)) {
      return value.map(sortedValue);
    }

    if (value && typeof value === 'object') {
      return Object.keys(value).sort().reduce(function (copy, key) {
        defineOwn(copy, key, sortedValue(value[key]));
        return copy;
      }, {});
    }

    return value;
  }

  function compareStrings(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
  }

  function cartItemsSignature(cartOrItems) {
    var items = snapshotCartItems(cartOrItems).map(function (item) {
      var normalized = { id: item.id, quantity: item.quantity };

      if (item.properties) {
        normalized.properties = sortedValue(item.properties);
      }
      if (item.selling_plan) {
        normalized.selling_plan = item.selling_plan;
      }

      return normalized;
    });

    items.sort(function (left, right) {
      var comparisons = [
        compareStrings(left.id, right.id),
        compareStrings(left.selling_plan || '', right.selling_plan || ''),
        compareStrings(JSON.stringify(left.properties || {}), JSON.stringify(right.properties || {})),
        left.quantity - right.quantity,
      ];

      return comparisons.find(function (comparison) { return comparison !== 0; }) || 0;
    });

    return JSON.stringify(items);
  }

  return {
    normalizePostalCode: normalizePostalCode,
    consolidateSimulationItems: consolidateSimulationItems,
    buildComboSimulationItems: buildComboSimulationItems,
    snapshotCartItems: snapshotCartItems,
    cartItemsSignature: cartItemsSignature,
  };
}));
